import { ApiProperty } from "@nestjs/swagger";

export class invoiceNumberRequest{
    @ApiProperty()
    invoiceNumber:string;
}